import { render, staticRenderFns } from "./ProductDashboardBulletPoints.vue?vue&type=template&id=587b83bc"
import script from "./ProductDashboardBulletPoints.vue?vue&type=script&lang=js"
export * from "./ProductDashboardBulletPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports